import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Alert, Spin } from "antd";
import { SelectForm } from "../../../Buttons";
import { FlopppyButton } from "../../../ButtonWithLoading";
import { useDispatch } from "react-redux";
import { updateOrderAddress } from "../../../../../redux/Actions/orderAction";
import Axios from "axios";
import TextInputModal from "../../../TextInputModal";
import { getPaymentsTypesOptions } from "../../../../../redux/Actions/paymentAction";
import {
  orderTypeMount,
  show_parcels,
} from "../../../../../helpers/OrdersFunctionsGlobal";
import SelectParcelTerminalInput from "../../../../globals/SelectParcelTerminalInput";

function DeliveryBlockChange({
  shipping_address,
  orderId,
  carrier,
  updateShippingAddress,
  total_shipping,
  payment,
  order_shop_id,
}) {
  const dispatch = useDispatch();
  const [payment_types, setPaymentsArr] = useState([]);

  const [carrierId, setCarrierId] = useState(carrier.id);
  //
  const [deliveryPrice, setDeliveryPrice] = useState(total_shipping);
  const [paymentType, setPaymentType] = useState(payment);
  const [parcelId, setParcelId] = useState(shipping_address.parcel_terminal_id);

  const [loading, setLoading] = useState(false);
  const [loadingArr, setLoadingArr] = useState(true);
  const [carrierArr, setCarrierArr] = useState([]);
  const [message, setMessage] = useState({
    show: false,
  });

  useEffect(() => {
    const getPayments = async () => {
      const { data, success } = await getPaymentsTypesOptions(order_shop_id);
      if (success) {
        setPaymentsArr(data);
      }
    };
    getPayments();
  }, []);

  useEffect(() => {
    const fetchCarriers = async () => {
      try {
        const { data } = await Axios.get(
          `/api/v1/carriers/active?&q[order_shop_id_eq]=${order_shop_id}`
        );
        if (data) {
          const carrierResp = data.reverse();
          let carrierArr = [];
          const findCarrier = carrierResp.find((f) => f.id == carrier.id);
          if (findCarrier) {
            carrierArr.push({
              ...findCarrier,
              value: findCarrier.id,
              identifier: findCarrier.identifier,
              label: `[${findCarrier?.order_shop?.identifier || ""}] ${findCarrier.name
                }`,
              // module_name: findCarrier.module_name,
            });
          }
          carrierResp.forEach((e) => {
            if (!e.order_shop_id) {
              return;
            }

            const findIndex = carrierArr.findIndex(
              (i) => i.label == `[${e?.order_shop?.identifier || ""}] ${e.name}`
            );
            if (findIndex == -1) {
              carrierArr.push({
                ...e,
                value: e.id,
                identifier: e.identifier,
                label: `[${e?.order_shop?.identifier || ""}] ${e.name}`,
                // module_name: e.module_name,
              });
            }
          });
          setCarrierArr(carrierArr);
          setLoadingArr(false);
        }
      } catch (e) {
        console.log(e);
      }
    };
    fetchCarriers();
  }, [order_shop_id]);

  const current_carrier = useMemo(() => {
    const c_carrier = carrierArr.find((item) => item.id === carrierId);
    if (!c_carrier) return null;
    const { order_type, delivery } = orderTypeMount(
      c_carrier,
      shipping_address.parcel_terminal_id
    );
    return {
      order_type,
      delivery,
      carrier: c_carrier,
    };
  }, [carrierId, carrierArr]);

  const activeParcelTerminal = useMemo(() => {
    if (!current_carrier) return false;
    return show_parcels(current_carrier.order_type, current_carrier.delivery);
  }, [current_carrier]);

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    delete shipping_address.valid_phone;
    let params = {
      total_shipping: deliveryPrice,
      total_shipping_tax_incl: deliveryPrice,
      total_shipping_tax_excl: deliveryPrice,
      payment: paymentType,
    };
    const findItem = payment_types.find((e) => e.title == paymentType);
    if (findItem) {
      params.payment_module = findItem.module_name;
    }
    if (current_carrier.carrier.identifier === "store") {
      params.shipping_address_attributes = {
        ...shipping_address,
        parcel_terminal_id: null,
      };
    } else {
      if (activeParcelTerminal) {
        params.shipping_address_attributes = {
          ...shipping_address,
          parcel_terminal_id: parcelId,
        };
      } else {
        params.shipping_address_attributes = {
          ...shipping_address,
          parcel_terminal_id: null,
        };
      }
    }

    params = {
      ...params,
      carrier_id: carrierId,
    };
    delete params.shipping_address_attributes.country;

    dispatch(updateOrderAddress(orderId, params)).then((res) => {
      if (res?.ok) {
        updateShippingAddress(params.shipping_address_attributes);
        setMessage({
          show: true,
          status: "success",
          message: `Successfully updated ${current_carrier.carrier.label || ""
            }`,
        });
      } else if (res?.error) {
        setMessage({
          show: true,
          status: "error",
          message: res?.error,
        });
      } else {
        setMessage({
          show: true,
          status: "error",
          message: "There was an error updating.",
        });
      }
      setLoading(false);
    });
  };

  const onChangeParcelTerminal = useCallback((value) => setParcelId(value), []);

  if (loadingArr) {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Spin />
      </div>
    );
  }

  return (
    <React.Fragment>
      {message.show && (
        <Alert message={message.message} type={message.status} />
      )}

      <form className="row" onSubmit={onSubmit}>
        <div className="col-12">
          <SelectForm
            options={payment_types}
            placeholder="Payment"
            selector="order_type"
            value={paymentType}
            dropdownMatchSelectWidth={false}
            onChange={(value) => setPaymentType(value)}
          />
        </div>
        <div className="col-12">
          <SelectForm
            options={carrierArr}
            placeholder="Delivery method"
            selector="order_type"
            value={carrierId}
            dropdownMatchSelectWidth={false}
            onChange={(value) => {
              setCarrierId(value);
              setParcelId(undefined);
            }}
          />
        </div>
        {activeParcelTerminal && (
          <div className="col-12">
            <SelectParcelTerminalInput
              label="Parcel terminal"
              value={parcelId}
              shipment_type={current_carrier.order_type}
              delivery={current_carrier.delivery}
              country_id={shipping_address?.country_id}
              onChange={onChangeParcelTerminal}
            />
          </div>
        )}
        <div className="col-12">
          <TextInputModal
            type="number"
            text="Delivery price"
            value={deliveryPrice}
            onChange={(e) => setDeliveryPrice(e.target.value)}
          />
        </div>
        <div className="col-10"></div>
        <div className="col-2">
          <div className="mt-2 float-right">
            <FlopppyButton
              loading={loading}
              disabled={
                activeParcelTerminal ? !carrierId || !parcelId : !carrierId
              }
              style={{ height: 32 }}
              onClick={(e) => onSubmit(e)}
            />
          </div>
        </div>
      </form>
    </React.Fragment>
  );
}
export default DeliveryBlockChange;
